'use client'

import { memo } from 'react'
import { CraftConstellation } from './constellation/craft-constellation'

/**
 * baby: Journey section. Constellation Workbench (scroll scrub + nodes), not classic fixed scrub.
 */
export const CraftJourney = memo(function CraftJourney() {
  return (
    <section
      id="journey"
      data-section="journey"
      className="craft-journey"
      aria-label="NINX paper journey"
    >
      <div className="craft-journey__intro craft-journey__intro--constellation">
        <p className="craft-section__eyebrow">Journey</p>
        <h2 className="craft-section__title">Follow the twine</h2>
        <p className="craft-section__body">
          After the hands meet the model, scroll the map: desk → models → InkFlow → tools → vault
          → download. Scenes sit in the kraft, not in a card.
        </p>
      </div>
      <CraftConstellation />
    </section>
  )
})

CraftJourney.displayName = 'CraftJourney'
